import { observer } from 'mobx-react';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router';

import { LinearProgress, useMediaQuery } from '@mui/material';

import useStores from 'hooks/use-stores';
import LetterAvatar from 'main/components/LetterAvatar';

import ActionTooltip from './components/ActionTooltip';
import FeedbackButton from './components/FeedbackButton';
import SignInButton from './components/SignInButton';
import SupportButton from './components/SupportButton';
import useStyles from './styles';

interface Props {
    className?: string;
}

const Authorization: React.FC<Props> = ({ className }) => {
    const history = useHistory();
    const { classes, cx } = useStyles();
    const { userStore } = useStores();
    const isCompact = useMediaQuery(`@media (min-width: 481px) and (max-width: 1024px)`);

    const goToUserInfo = useCallback(() => history.push('/userinfo'), [history]);

    if (userStore.isLoading) {
        return null;
    }

    if (!userStore.isAuthorized) {
        return (
            <div className={cx(classes.root, className)}>
                <SignInButton />
                <SupportButton />
            </div>
        );
    }

    if (isCompact) {
        return (
            <ActionTooltip>
                <div className={cx(classes.root, classes._compact, className)}>
                    <LetterAvatar className={classes.avatar} name={userStore.user.fullName} onClick={goToUserInfo} />
                    <FeedbackButton compact />
                    <SupportButton compact />
                </div>
            </ActionTooltip>
        );
    }

    return (
        <ActionTooltip>
            <div className={cx(classes.root, className)}>
                <div className={classes.user}>
                    <LetterAvatar className={classes.avatar} name={userStore.user.fullName} onClick={goToUserInfo} />
                    <div className={classes.text}>
                        <span className={classes.name}>{userStore.user.fullName}</span>
                        <span className={classes.credits} data-after="credits left">
                            {userStore.userCredits}
                        </span>
                    </div>
                </div>
                <LinearProgress
                    variant="determinate"
                    className={classes.progress}
                    value={(userStore.userCredits / (userStore.userCredits + userStore.licenseSpent)) * 100}
                />
                <div className={classes.buttons}>
                    <FeedbackButton />
                    <SupportButton />
                </div>
            </div>
        </ActionTooltip>
    );
};

export default observer(Authorization);
